"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Sets the aspect ratio of an element of collection of elements based on width or height.
 * For example, if the height of an element is known, and aspect ratio needs to be set for width, then the params would include elem(s), width, aspect ratio (3/1).
 * Doing so will result to width being 3 times of height.
 * Aspect ratio is always width / height.
 * @param {(Element | Element[])} selector - This is the element node(s) which can be a single element or an array of elements that the aspect ratio is to be applied to.
 * @param {string} [measurement=width] - This is the measurement type the aspect ratio is to be applied to. For example, if the height needs to scale to the ratio of the existing width, then the 'height' measurement type needs to be set.
 * @param {number} [ratio=1] - This is the ratio to be set on the element. Ratio is calculated based on width / height. For example, if 'height' is passed as measurement type, and it needs to have 2:1 aspect ratio to width, then the ratio is 1/2 or 0.5.
 */
var setAspectRatio = function setAspectRatio(selector) {
  var measurement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  // Check that measurement type passed is a valid type if not, default to width
  var measurementType = measurement.includes('width') || measurement.includes('height') ? measurement : 'width';
  var isWidth = measurementType === 'width';
  var isHeight = measurementType === 'height';
  // Check selector for valid element
  var isElement = selector && selector instanceof Element;
  // Check selector as array or collection of valid element
  var isValidCollection = (selector === null || selector === void 0 ? void 0 : selector.length) > 0 && (selector === null || selector === void 0 ? void 0 : selector[0]) instanceof Element;

  // Resize selector based on aspect ratio
  if (isElement && isHeight) selector.style.height = "".concat(selector.offsetWidth / ratio, "px");
  if (isElement && isWidth) selector.style.width = "".concat(selector.offsetHeight * ratio, "px");
  // If selector is an HTML collection or array, resize each element based on aspect ratio
  if (isValidCollection && isHeight) selector.forEach(function (el) {
    el.style.height = "".concat(el.offsetWidth / ratio, "px");
  });
  if (isValidCollection && isWidth) {
    selector.forEach(function (el) {
      el.style.width = "".concat(el.offsetHeight * ratio, "px");
    });
  }
};
var _default = exports["default"] = setAspectRatio;